export default "__VITE_ASSET__B3RR6IZR__"